var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSologicLogoImproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 252 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n                        .headlogo-1 {\n                            clip-path: url(#clip-Sologic-Logo);\n                        }\n\n                        .headlogo-2 {\n                            fill: #95bf3c;\n                        }\n\n                        .headlogo-3 {\n                            fill: #7c8790;\n                        }\n\n                        .headlogo-4 {\n                            fill: transparent;\n                        }\n                    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Sologic-Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 36
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sologic-Logo",
    className: "head-logo-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "headlogo-4",
    width: 252,
    height: 36
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(0 0.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    className: "headlogo-2",
    d: "M54.576,0,41.2,13.328l6.107,6.107,1.842-1.842-4.265-4.265,9.693-9.645,18.8,18.8-9.645,9.693L52.153,20.646,50.36,22.488,63.736,35.864,77.064,22.488Z",
    transform: "translate(-21.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    className: "headlogo-3",
    d: "M29.224,19.968l6.64-6.64L29.757,7.221,27.916,9.063l4.265,4.265L13.328,32.181,3.683,22.488l18.8-18.8,2.423,2.375,1.842-1.842L22.488,0,0,22.488,13.328,35.864,27.916,21.276h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(68.19 8.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    className: "headlogo-3",
    d: "M144.626,23.161c0-2.181,1.939-3,4.556-3a13.913,13.913,0,0,1,5.186,1.018l.582-3.2a22.666,22.666,0,0,0-5.913-.775c-4.313,0-7.851,2.326-7.851,6.494,0,6.543,11.2,6.882,11.2,12.068,0,2.181-1.987,3.441-4.313,3.441a11.653,11.653,0,0,1-6.3-1.939l-1.066,3.1a14.537,14.537,0,0,0,7.221,1.793c4.8,0,8-2.714,8-6.834C155.918,28.347,144.626,27.814,144.626,23.161Z",
    transform: "translate(-140.7 -17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    className: "headlogo-3",
    d: "M199.246,17.2c-6.785,0-12.746,4.653-12.746,13.037a11.73,11.73,0,0,0,11.922,11.971c6.737,0,12.892-4.556,12.892-12.94A11.791,11.791,0,0,0,199.246,17.2Zm-.485,22c-4.943,0-8.724-3.344-8.724-9.5,0-6.2,4.313-9.548,9.014-9.548,4.556,0,8.675,3.1,8.675,9.451C207.776,35.18,204,39.2,198.762,39.2Z",
    transform: "translate(-164.303 -17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    className: "headlogo-3",
    d: "M258.644,18.1H255.3V42.332h14.2l.194-3h-11.05Z",
    transform: "translate(-199.759 -17.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    className: "headlogo-3",
    d: "M310.046,17.2c-6.785,0-12.746,4.653-12.746,13.037a11.73,11.73,0,0,0,11.922,11.971c6.737,0,12.892-4.556,12.892-12.94A11.791,11.791,0,0,0,310.046,17.2Zm-.485,22c-4.943,0-8.724-3.344-8.724-9.5,0-6.2,4.313-9.548,9.014-9.548,4.556,0,8.675,3.1,8.675,9.451C318.576,35.18,314.8,39.2,309.562,39.2Z",
    transform: "translate(-221.404 -17.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1150",
    "data-name": "Rectangle 1150",
    className: "headlogo-3",
    width: 3.344,
    height: 24.232,
    transform: "translate(138.464 0.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    className: "headlogo-3",
    d: "M470.528,37.122a13.753,13.753,0,0,1-6.882,2.084c-4.459,0-9.16-2.714-9.16-8.966,0-7.221,4.313-9.887,8.821-9.887a13.96,13.96,0,0,1,6.737,1.745l.969-3.15a17.885,17.885,0,0,0-7.754-1.648c-5.816,0-12.359,4.023-12.359,12.94,0,7.609,5.864,12.019,12.165,12.019a17.708,17.708,0,0,0,8.288-1.939Z",
    transform: "translate(-300.562 -17.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    className: "headlogo-3",
    d: "M375.24,32.37h4.992v6.01a18.293,18.293,0,0,1-4.7.775c-5.331,0-9.693-3.15-9.693-9.208,0-7.367,4.8-9.693,9.014-9.693a15.766,15.766,0,0,1,7.124,1.89l1.018-3.247a21.659,21.659,0,0,0-8.433-1.7c-5.913,0-12.262,4.168-12.262,12.795,0,7.706,5.719,12.165,12.455,12.165a24.922,24.922,0,0,0,8.821-1.6V29.7H375.24Z",
    transform: "translate(-254.902 -17.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(237 3) scale(0.5531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    className: "headlogo-3",
    d: "M519.3,36a7.75,7.75,0,1,1,7.75-7.75A7.68,7.68,0,0,1,519.3,36Zm0-14.44a6.69,6.69,0,1,0,6.63,6.69A6.56,6.56,0,0,0,519.3,21.51Zm2.42,11L519,29h-1.27v3.39h-1.46V23.68h.82s1.79-.07,2.22-.07c1.82,0,3,.93,3,2.56a2.41,2.41,0,0,1-1.86,2.39v.07l2.84,3.63Zm-2.8-7.65c-.36,0-.81,0-1.15,0v2.83h1c1.39,0,2-.53,2-1.44S520.12,24.88,518.92,24.88Z",
    transform: "translate(-502.5 -20.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSologicLogoImproved);
export default __webpack_public_path__ + "static/media/sologic-logo-improved.bb5ea5c69c577826a3b51f1600c8a44e.svg";
export { ForwardRef as ReactComponent };